import { useEffect, useState } from 'react';
import { createStore } from 'react-hooks-global-state';
import { Topics } from '../conf/Config';
import { Events, JSEvent } from '../utils/JSEvent';
import DataCenter, { Connections, TransactionMethod } from './DataCenter';
import { TransactionState, WalletTxInfo } from './WalletService';

class TransactionInfoUpdate {
    /**
     * transaction对应的orderId
     */
    orderId = 0;

    transferNet = "";
    transactionHash = "";
    /**
     * 交易状态
     *
     * @see TransactionState
     */
    state = 0;

    /**
     * 交易结果
     * -1 or >0
     */
    result = 0;
    /**
     * 状态附加消息
     */
    msg = "";
}

export class TransactionService {
    static #inst = null;
    /**
     * 
     * @returns {TransactionService} inst
     */
    static Inst = () => {
        if (TransactionService.#inst == null) {
            TransactionService.#inst = new TransactionService();
        }
        return TransactionService.#inst;
    }

    constructor() {

    }

    /**
     * 所有进行中的transaction
     * 结构是WalletTxInfo
     * @see WalletTxInfo
     */
    transactions = [];

    /**
     * trans变更回调
     * event:{
     *     trans:WalletTxInfo,
     *     state:"created" | "updated" | "removed"
     * }
     */
    #onTransCallback = [];

    /**
     * 
     * @param {WalletTxInfo} txInfo 
     */
    addOrUpdateTrans(txInfo) {
        console.log("addOrUpdateTrans:", txInfo)
        const found = txInfo.orderId == 0 ?
            findTransByHash(this.transactions, txInfo.transactionHash) :
            findTrans(this.transactions, txInfo.orderId)

        if (found != -1) {
            this.transactions[found] = txInfo;
            this.#fireTransEvent(txInfo, "updated");
        } else {
            this.transactions.unshift(txInfo);
            this.#fireTransEvent(txInfo, "created");
        }
    }

    /**
     * 
     * @param {TransactionInfoUpdate} txInfoUpdate 
     */
    updateTrans(txInfoUpdate) {
        const found = findTrans(this.transactions, txInfoUpdate.orderId);

        if (found != -1) {
            for (const key in txInfoUpdate) {
                this.transactions[found][key] = txInfoUpdate[key];
            }
            this.#fireTransEvent(this.transactions[found], "updated");
        }
    }

    removeTrans(txInfo) {
        const found = txInfo.orderId == 0 ?
            findTransByHash(this.transactions, txInfo.transactionHash) :
            findTrans(this.transactions, txInfo.orderId)
        if (found != -1) {
            const removed = this.transactions[found];
            this.transactions.splice(found, 1);
            this.#fireTransEvent(removed, "removed");
        }
    }

    /**
     * 
     * @param {Function } f 
     */
    addOnTransListener(f) {
        this.#onTransCallback.push(f);
    }

    removeOnTransListener(f) {
        for (let i = 0; i < this.#onTransCallback.length; i++) {
            if (this.#onTransCallback[i] == f) {
                this.#onTransCallback.splice(i, 1);
                break;
            }
        }
    }

    /**
     * 
     * @param {WalletTxInfo} txInfo 
     * @param {"created" | "updated" | "removed"} state 
     */
    #fireTransEvent(txInfo, state) {
        console.log("TransactionService %s %s %s", txInfo.orderId, state, txInfo.state, txInfo.result)
        if (state == "updated" && txInfo.state == TransactionState.TRANSACTION_STATE_SENT) {
            //已完成的订单，5秒后移除
            setTimeout(() => { this.removeTrans(txInfo) }, 30000)
        }
        this.#onTransCallback.forEach(c => {
            c?.(txInfo, state)
        })
    }

}


/**
 * @param {[]} trans
 * @param {number} orderId 
 * @returns {number} index
 */
const findTrans = (trans, orderId) => {
    let found = -1;
    for (let i = 0; i < trans.length; i++) {
        if (trans[i].orderId == orderId) {
            found = i;
            break;
        }
    }
    return found;
}

const findTransByHash = (trans, transHash) => {
    let found = -1;
    for (let i = 0; i < trans.length; i++) {
        if (trans[i].transactionHash == transHash) {
            found = i;
            break;
        }
    }
    return found;
}

JSEvent.on(Events.DataCenter.DATA_READY, () => {
    if (Connections.exchange) {
        Connections.exchange.subscribe(Topics.exchange_user_trans, (topic, msg) => {
            const infoUpdate = JSON.parse(msg.body);
            TransactionService.Inst().updateTrans(infoUpdate);
        });
    }
})

const onPendingTransaction = ({ token, walletTxInfo }) => {
    walletTxInfo.state = TransactionState.TRANSACTION_STATE_PROCESSING;
    TransactionService.Inst().addOrUpdateTrans(walletTxInfo);
}

const onTransaction = ({ token, trans, walletTxInfo }) => {
    if (walletTxInfo.txMethod == TransactionMethod.Transfer) {
        //transfer的订单需要客户端自己监听
        walletTxInfo.state = walletTxInfo.result = TransactionState.TRANSACTION_STATE_SENT;
        TransactionService.Inst().addOrUpdateTrans(walletTxInfo);
    }
}

JSEvent.on(Events.Wallet.PenddingTransaction, onPendingTransaction)
JSEvent.on(Events.Wallet.Transaction, onTransaction)

export const useTrans = () => {
    const inst = TransactionService.Inst();
    const [trans, setTrans] = useState(inst.transactions);

    const onTransState = (t, s) => {
        setTrans([...inst.transactions]);
    }

    useEffect(() => {
        inst.addOnTransListener(onTransState);
        return () => inst.removeOnTransListener(onTransState);
    }, [])

    const addTrans = (...p) => inst.addOrUpdateTrans(...p);
    const removeTrans = (...p) => inst.removeTrans(...p);

    return [trans, addTrans, removeTrans];
}


